import React, { useCallback, useEffect, useRef, useState, } from 'react';
import { ImageErrorPlaceholder } from '@yme/atoms/image-error-placeholder';
import { buildKey } from '@yme/utils/common';
import { IMAGE } from './constants';
import { GalleryItemStyled, GalleryListStyled } from './styled';
export function GalleryList({ items, isDraggable, isRightToLeft, addErrorItem, isErrorItem, currentIndex, isZoomed, isInLightbox, }) {
    const [coordinates, setCoordinates] = useState({
        yOffset: 0,
        xOffset: 0,
    });
    const [isHovered, setIsHovered] = useState(false);
    const galleryItemRef = useRef(null);
    const itemsRef = useRef(items);
    useEffect(() => {
        itemsRef.current = items;
    }, [items]);
    const onMouseMove = useCallback((e) => {
        if (galleryItemRef.current) {
            setIsHovered(true);
            const halfWidth = Math.round(galleryItemRef.current.clientWidth / 2);
            const halfHeight = Math.round(galleryItemRef.current.clientHeight / 2);
            const clientRect = galleryItemRef.current.getBoundingClientRect();
            const relX = Math.round(e.clientX - clientRect.left) -
                galleryItemRef.current.clientWidth * currentIndex;
            const relY = Math.round(e.clientY - clientRect.top);
            const yOffset = relY > 0 ? -(relY - halfHeight) : halfHeight;
            const xOffset = relX > 0 ? -(relX - halfWidth) : halfWidth;
            setCoordinates({
                yOffset,
                xOffset,
            });
        }
    }, [currentIndex]);
    const onMouseLeave = () => {
        setIsHovered(false);
        setCoordinates({
            yOffset: 0,
            xOffset: 0,
        });
    };
    const prepareGalleryItem = useCallback((element, elementType) => {
        const isImageType = elementType === IMAGE;
        if (isImageType && isZoomed) {
            const { yOffset, xOffset } = coordinates;
            return (React.createElement("div", { style: {
                    width: '100%',
                    height: '100%',
                    position: 'relative',
                    top: yOffset,
                    left: xOffset,
                } }, element));
        }
        return element;
    }, [coordinates, isZoomed]);
    return (React.createElement(GalleryListStyled, { currentIndex: currentIndex, isDraggable: isDraggable, isRightToLeft: isRightToLeft, ref: isZoomed ? galleryItemRef : null, onMouseMove: isZoomed ? onMouseMove : undefined, onMouseLeave: isZoomed ? onMouseLeave : undefined }, itemsRef.current.length ? (itemsRef.current.map((item, index) => (React.createElement(GalleryItemStyled, { isInLightbox: isInLightbox, isHovered: isHovered, onError: () => addErrorItem(index), key: buildKey('key', index) }, isErrorItem(index) ? (React.createElement(ImageErrorPlaceholder, { hasBackground: true })) : (prepareGalleryItem(item.element, item?.elementType)))))) : (React.createElement(ImageErrorPlaceholder, { hasBackground: true }))));
}
